var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    { staticClass: "step-two", style: { height: _vm.viewportHeight } },
    [
      _c("HomeHeader", { attrs: { "scroll-top": "300" } }),
      _c("div", { staticClass: "flex-column container w-wrapper" }, [
        _c("div", { staticClass: "flex-column main" }, [
          _c("div", { staticClass: "title" }, [_vm._v("企业MCN机构申请")]),
          _c(
            "div",
            { staticClass: "steps-box" },
            [
              _c(
                "el-steps",
                { attrs: { active: 2, "align-center": "" } },
                [
                  _c("el-step", { attrs: { title: "选择公会类型" } }),
                  _c("el-step", { attrs: { title: "填写公会信息" } }),
                  _c("el-step", { attrs: { title: "填写资质信息" } }),
                  _c("el-step", { attrs: { title: "确认信息" } }),
                  _c("el-step", { attrs: { title: "等待审核" } }),
                  _c("el-step", { attrs: { title: "完成入驻" } }),
                ],
                1
              ),
            ],
            1
          ),
          _c(
            "div",
            { staticClass: "form-box" },
            [
              _c(
                "el-form",
                {
                  ref: "ruleForm",
                  staticClass: "demo-ruleForm",
                  attrs: {
                    model: _vm.ruleForm,
                    rules: _vm.rules,
                    "label-width": "140px",
                  },
                },
                [
                  _vm.oneStepDetail.mcnType === 1
                    ? _c(
                        "el-form-item",
                        { attrs: { label: "", "label-width": "0" } },
                        [
                          _c(
                            "div",
                            {
                              staticStyle: {
                                "font-weight": "bold",
                                width: "100px",
                                "text-align": "right",
                                "font-size": "16px",
                              },
                            },
                            [_vm._v("企业资质")]
                          ),
                        ]
                      )
                    : _vm._e(),
                  _vm.oneStepDetail.mcnType === 1
                    ? _c(
                        "el-form-item",
                        {
                          attrs: {
                            label: "营业执照",
                            prop: "businessLicenseUrl",
                          },
                        },
                        [
                          _c(
                            "div",
                            [
                              _c(
                                "div",
                                { staticClass: "flex-row-h-center" },
                                [
                                  _c("directUploadOne", {
                                    attrs: {
                                      model: "img",
                                      size: "10MB",
                                      imgUrl: _vm.ruleForm.businessLicenseUrl,
                                    },
                                    on: {
                                      "update:imgUrl": function ($event) {
                                        return _vm.$set(
                                          _vm.ruleForm,
                                          "businessLicenseUrl",
                                          $event
                                        )
                                      },
                                      "update:img-url": function ($event) {
                                        return _vm.$set(
                                          _vm.ruleForm,
                                          "businessLicenseUrl",
                                          $event
                                        )
                                      },
                                    },
                                  }),
                                  _c(
                                    "div",
                                    { staticStyle: { "margin-left": "10px" } },
                                    [
                                      _vm._v(
                                        "文件格式仅支持png、jpeg，大小不超过10M"
                                      ),
                                    ]
                                  ),
                                ],
                                1
                              ),
                              _c("BusinessLicense"),
                            ],
                            1
                          ),
                        ]
                      )
                    : _vm._e(),
                  _vm.oneStepDetail.mcnType === 1
                    ? _c(
                        "el-form-item",
                        {
                          attrs: {
                            label: "企业名称",
                            prop: "businessLicenseName",
                          },
                        },
                        [
                          _c("el-input", {
                            attrs: { maxlength: "20" },
                            model: {
                              value: _vm.ruleForm.businessLicenseName,
                              callback: function ($$v) {
                                _vm.$set(
                                  _vm.ruleForm,
                                  "businessLicenseName",
                                  typeof $$v === "string" ? $$v.trim() : $$v
                                )
                              },
                              expression: "ruleForm.businessLicenseName",
                            },
                          }),
                        ],
                        1
                      )
                    : _vm._e(),
                  _vm.oneStepDetail.mcnType === 1
                    ? _c(
                        "el-form-item",
                        { attrs: { label: "其他许可证" } },
                        [
                          _c("directUploadMultiple", {
                            attrs: {
                              model: "img",
                              limit: 9,
                              size: "10MB",
                              "file-list": _vm.ruleForm.otherLicenseList,
                            },
                            on: {
                              "update:fileList": function ($event) {
                                return _vm.$set(
                                  _vm.ruleForm,
                                  "otherLicenseList",
                                  $event
                                )
                              },
                              "update:file-list": function ($event) {
                                return _vm.$set(
                                  _vm.ruleForm,
                                  "otherLicenseList",
                                  $event
                                )
                              },
                            },
                          }),
                          _c(
                            "div",
                            [
                              _c("div", { staticClass: "flex-row" }, [
                                _c("div", [
                                  _vm._v(
                                    "文件格式仅支持png、jpeg，大小不超过10M"
                                  ),
                                ]),
                              ]),
                              _c("CertificateDec"),
                            ],
                            1
                          ),
                        ],
                        1
                      )
                    : _vm._e(),
                  _c(
                    "el-form-item",
                    { attrs: { label: "", "label-width": "0", prop: "name" } },
                    [
                      _c(
                        "div",
                        {
                          staticStyle: {
                            "font-weight": "bold",
                            width: "100px",
                            "text-align": "right",
                            "font-size": "16px",
                          },
                        },
                        [_vm._v("主播信息")]
                      ),
                    ]
                  ),
                  _c(
                    "el-form-item",
                    { attrs: { label: "签约主播数量", prop: "anchorAmount" } },
                    [
                      _c("el-input-number", {
                        staticStyle: { width: "60%" },
                        attrs: {
                          "controls-position": "right",
                          step: 1,
                          min: 5,
                          precision: 0,
                          placeholder: "请输入",
                          max: 9999999999,
                        },
                        model: {
                          value: _vm.ruleForm.anchorAmount,
                          callback: function ($$v) {
                            _vm.$set(_vm.ruleForm, "anchorAmount", $$v)
                          },
                          expression: "ruleForm.anchorAmount",
                        },
                      }),
                    ],
                    1
                  ),
                  _c(
                    "el-form-item",
                    { attrs: { label: "签约主播证明材料" } },
                    [
                      _c("directUploadMultiple", {
                        attrs: {
                          model: "img",
                          limit: 9,
                          size: "10MB",
                          "file-list": _vm.ruleForm.anchorEvidentiaryList,
                        },
                        on: {
                          "update:fileList": function ($event) {
                            return _vm.$set(
                              _vm.ruleForm,
                              "anchorEvidentiaryList",
                              $event
                            )
                          },
                          "update:file-list": function ($event) {
                            return _vm.$set(
                              _vm.ruleForm,
                              "anchorEvidentiaryList",
                              $event
                            )
                          },
                        },
                      }),
                      _c("div", [
                        _c("div", { staticClass: "flex-row" }, [
                          _c("div", [
                            _vm._v("文件格式仅支持png、jpeg，大小不超过10M"),
                          ]),
                        ]),
                      ]),
                    ],
                    1
                  ),
                  _c(
                    "el-form-item",
                    { attrs: { label: "签约主播来源", prop: "anchorSource" } },
                    [
                      _c(
                        "div",
                        [
                          _c("el-input", {
                            attrs: {
                              type: "textarea",
                              maxlength: "200",
                              "show-word-limit": "",
                              rows: "8",
                              placeholder: "请输入",
                            },
                            model: {
                              value: _vm.ruleForm.anchorSource,
                              callback: function ($$v) {
                                _vm.$set(
                                  _vm.ruleForm,
                                  "anchorSource",
                                  typeof $$v === "string" ? $$v.trim() : $$v
                                )
                              },
                              expression: "ruleForm.anchorSource",
                            },
                          }),
                        ],
                        1
                      ),
                      _c("div", [_vm._v("示例：好友推荐、市场签约")]),
                    ]
                  ),
                  _c(
                    "el-form-item",
                    [
                      _c(
                        "el-row",
                        { attrs: { gutter: 12 } },
                        [
                          _c(
                            "el-col",
                            { attrs: { span: 8 } },
                            [
                              _c(
                                "el-button",
                                {
                                  staticStyle: { width: "100%" },
                                  attrs: { type: "default" },
                                  on: {
                                    click: function ($event) {
                                      return _vm.onPre()
                                    },
                                  },
                                },
                                [_vm._v("上一步 ")]
                              ),
                            ],
                            1
                          ),
                          _c(
                            "el-col",
                            { attrs: { span: 8 } },
                            [
                              _c(
                                "el-button",
                                {
                                  staticStyle: { width: "100%" },
                                  attrs: { type: "primary" },
                                  on: {
                                    click: function ($event) {
                                      return _vm.submitForm()
                                    },
                                  },
                                },
                                [_vm._v("下一步 ")]
                              ),
                            ],
                            1
                          ),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                ],
                1
              ),
            ],
            1
          ),
        ]),
      ]),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }